import { apiClient, publicClient } from './axiosInstance';
import { ensureOk } from '../helpers/api-helper';
import { ApiEnvelope } from '@/types/apiEnvelope';

export type UnitTag = {
  id: number;
  tag_main_id: number;
  name: string;
  sort: number;
  tag_main_name: string;
};

export type AllTags = {
  data: UnitTag[];
};

export type MyTag = {
  tag_id: number;
  user_id: number;
  name: string;
  tag_main_id: number;
  tag_main_name: string;
};

export type MyTagData = {
  data: MyTag[];
  num: number;
};

export const TagsService = {
  async getAllTags() {
    const { data } = await publicClient.get<ApiEnvelope<AllTags>>('/tag');
    const result = ensureOk<AllTags>(data);
    return result.data;
  },
  async getMyTags() {
    const { data } = await apiClient.get<ApiEnvelope<MyTagData>>('/tag/my_tag');

    const result = ensureOk<MyTagData>(data);
    return result.data;
  },
};
